












import BaseComponent from '@/components/BaseComponent';
import { Component, Watch } from 'vue-property-decorator';

@Component
export default class Alert extends BaseComponent {
    private activeTimeout: number = -1;

    // パラメータ取得
    get params() {
        return this.$store.getters['common/alert_params'];
    }
    // アイコンの設定
    get icons() {
        let icon_text: string = '';
        switch (this.params.type) {
            case 'success':
                icon_text = 'mdi-check-circle';
                break;
            case 'info':
                icon_text = 'mdi-information';
                break;
            case 'warning':
                icon_text = 'mdi-exclamation';
                break;
            case 'error':
                icon_text = 'mdi-alert';
                break;
        }
        return icon_text;
    }

    // timeoutが設定されている場合、設定時間経過後にcloseEventを呼ぶ
    @Watch('params.is_display')
    private timeoutEvent() {
        if (this.params.is_display) {
            window.clearTimeout(this.activeTimeout);
            if (this.params.timeout > 0) {
                this.activeTimeout = window.setTimeout(() => {
                    this.closeEvent();
                }, this.params.timeout);
            }
        }
    }

    // 閉じるイベント
    private closeEvent(): void {
        // ログイン画面に戻すフラグが有効の場合
        if (this.params.return_flg) {
            this.$router.push({ path: '/login' }, () => {});
        }
        this.$store.dispatch('common/setAlertParamsAc', {
            is_display: false,
            type: 'white',
            timeout: -1,
            message: '',
            return_flg: false,
        });
    }
}
